//
// Url util
// -------------

define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var langUtil = require('util/language.util');
    var urlUtil = require('util/url.util');

    module.exports = _.extend(urlUtil, {
        _parseUrl: function(path) {
            var url = _.compact(path && path.split('/'));
            const languageParam = this.getLocationParameterByName('language');
            // Lang always at the head of path
            var lang = langUtil.getLanguage(url[0]);

            if (lang) {
                // remove language from url if it's actually a language
                url.shift();
            }

            if (languageParam) {
                lang = langUtil.getLanguage(languageParam) || langUtil.defaultLocale;
            }
            var friendlyUrl = url.join('/');
            var cleanUrl = '/' + friendlyUrl;

            return {
                lang: lang,
                friendlyUrl: friendlyUrl,
                cleanUrl: cleanUrl
            };
        }
    });
});
